import { gql } from "graphql-request";
import { hygraphClient } from "./hygraph";
import { fallbackServices, fallbackForwhos } from "../data/fallback";
import type {
    ServicesResponse,
    ForwhosResponse,
    RealEstateResponse,
} from "../types/hygraph";

// Query to fetch services
const GET_SERVICES = gql`
    query GetServices {
        services(orderBy: order_ASC) {
            id
            title
            description
        }
    }
`;

// Query to fetch forwho items
const GET_FORWHOS = gql`
    query GetForwhos {
        forwhos(orderBy: order_ASC) {
            id
            title
        }
    }
`;

// Query to fetch real estate items with pagination
const GET_REAL_ESTATE = gql`
    query GetRealEstate($skip: Int = 0, $first: Int = 100) {
        realEstateItems(orderBy: createdAt_DESC, skip: $skip, first: $first) {
            id
            title
            description
            images(first: 100) {
                url
            }
            estate_type
        }
    }
`;

// Fetch services from Hygraph
export async function getServices() {
    try {
        const data = await hygraphClient.request<ServicesResponse>(
            GET_SERVICES
        );
        return data.services.length > 0 ? data.services : fallbackServices;
    } catch (error) {
        console.warn("Error fetching services, using fallback data:", error);
        return fallbackServices;
    }
}

// Fetch forwhos from Hygraph
export async function getForwhos() {
    try {
        const data = await hygraphClient.request<ForwhosResponse>(GET_FORWHOS);
        return data.forwhos.length > 0 ? data.forwhos : fallbackForwhos;
    } catch (error) {
        console.warn("Error fetching forwhos, using fallback data:", error);
        return fallbackForwhos;
    }
}

// Fetch real estate items from Hygraph with pagination
export async function getRealEstate(skip: number = 0, first: number = 100) {
    try {
        const data = await hygraphClient.request<RealEstateResponse>(
            GET_REAL_ESTATE,
            { skip, first }
        );
        return data.realEstateItems;
    } catch (error) {
        console.error("Error fetching real estate items:", error);
        return [];
    }
}
